import { render, staticRenderFns } from "./JobObjective.vue?vue&type=template&id=20f935ff&"
import script from "./JobObjective.vue?vue&type=script&lang=js&"
export * from "./JobObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports